import { AfterViewInit, Component, ElementRef, Input, ViewChild } from "@angular/core";

@Component({
  selector: 'video-display',
  template: `
    <div class="video-container">
      <video
        #videoPlayer
        [src]="videoSrc"
        controls
        class="responsive-video"
      >
        Your browser does not support the video tag.
      </video>
    </div>
  `,
  styles: [`
    .video-container {
      position: relative;
      width: 100%;
      max-width: 100%;
      aspect-ratio: 16 / 6; /* Maintain aspect ratio */
      background: #000;
      border-radius: 8px;
      overflow: hidden;
    }

    .responsive-video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    @media (max-width: 600px) {
      .video-container {
        aspect-ratio: 16 / 9;
        border-radius: 0;
      }
    }
  `]
})
export class VideoDisplayComponent implements AfterViewInit {
  @Input() videoPath: string = '';
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;

  get videoSrc(): string | null {
    return this.videoPath ? this.videoPath : null;
  }

  ngAfterViewInit() {
    const video = this.videoPlayer.nativeElement;
    video.currentTime = 1;
    video.pause();
  }
}
